import { render, staticRenderFns } from "./OrderConfirmation.vue?vue&type=template&id=1ff21976&scoped=true&"
import script from "./OrderConfirmation.vue?vue&type=script&lang=js&"
export * from "./OrderConfirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ff21976",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/sivaram/work/carthike/whatsapp-crm-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ff21976')) {
      api.createRecord('1ff21976', component.options)
    } else {
      api.reload('1ff21976', component.options)
    }
    module.hot.accept("./OrderConfirmation.vue?vue&type=template&id=1ff21976&scoped=true&", function () {
      api.rerender('1ff21976', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Automation/OrderConfirmation.vue"
export default component.exports